import {
  Align,
  Arrange,
  Container,
  Icon,
  IconButton,
  SvgAlertTriangle,
  SvgClose,
  Text,
  TextButton,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { showVideoUploadModal } from 'actions/videoUploads';
import { CONFIRM_DELETE_ITEM_MODAL } from 'constants/modalTypes';
import { CONTENT_UPLOAD_ACTION_WRITE } from 'constants/scopes';
import {
  VIDEO_VALIDATION_FILE_UNSUPPORTED,
  VIDEO_VALIDATION_FPS_TOO_HIGH,
  VIDEO_VALIDATION_MAX_DURATION,
  VIDEO_VALIDATION_RESOLUTION_TOO_HIGH,
  VIDEO_VALIDATION_SCAN_ERROR,
  VIDEO_VALIDATION_SUSPICIOUS,
} from 'constants/videoUploads';

import Scopes from 'components/scopes';

const PROCESS_MESSAGE_TEXT = {
  [VIDEO_VALIDATION_FILE_UNSUPPORTED]: 'File Unsupported',
  [VIDEO_VALIDATION_SUSPICIOUS]: 'Suspicious content found in file',
  [VIDEO_VALIDATION_SCAN_ERROR]: 'Failed to process',
  [VIDEO_VALIDATION_FPS_TOO_HIGH]: 'File FPS above limit',
  [VIDEO_VALIDATION_RESOLUTION_TOO_HIGH]: 'File resolution above limit',
  [VIDEO_VALIDATION_MAX_DURATION]: 'Video length above limit',
};

const ProcessErrorOverlay = ({ video }) => {
  const dispatch = useDispatch();

  const videoUploadValid = video.videoUploadValid;
  const videoUploadMessage = video.videoUploadMessage;
  const isVideoUpload = video.isUserUploadedVideo;

  // Only show if explicitly 'false' and NOT null/undefined
  const showOverlay = isVideoUpload && videoUploadValid === false;

  if (!showOverlay) {
    return null;
  }

  const onUploadClick = ev => {
    ev.preventDefault();
    ev.stopPropagation();

    dispatch(showVideoUploadModal(true));
  };

  const onRemoveVideo = () => {
    dispatch(openModal(CONFIRM_DELETE_ITEM_MODAL, { videos: [video] }));
  };

  return (
    <div className="theme-dark">
      <Container
        backgroundColor="overlay"
        contentColor="body"
        height="100%"
        position="absolute"
        width="100%"
        zIndex="3"
      >
        <Align alignment="center">
          <Arrange gap="small" autoFlow="row">
            <Arrange justifyContent="center">
              <Icon color="body" icon={<SvgAlertTriangle />} />
            </Arrange>
            <Text alignment="center">
              {PROCESS_MESSAGE_TEXT[videoUploadMessage] || 'Processing Error'}
            </Text>
            <Scopes names={CONTENT_UPLOAD_ACTION_WRITE}>
              <TextButton onClick={onUploadClick}>Upload New File</TextButton>
            </Scopes>
          </Arrange>
        </Align>
        <Container position="absolute" top="small" right="small">
          <IconButton
            altText="Delete video"
            iconColor="body"
            icon={<SvgClose />}
            onClick={onRemoveVideo}
          />
        </Container>
      </Container>
    </div>
  );
};

export default ProcessErrorOverlay;
